// Routes
import preloadRoute from './preloadRoute';

const INTENT_EVENTS = ['pointerover', 'pointerdown', 'focusin'] as const;
const INTERNAL_LINK = 'a[href^="/"]';

/**
 * Starts the chunk of a page when the pointer reaches a link to it (a tap on a phone starts at
 * `pointerdown`, a keyboard user at focus), so the click finds it downloaded. One listener for every
 * link of the app; each path is warmed once.
 */
const preloadOnIntent = (preload: (pathname: string) => void = preloadRoute) => {
  const warmed = new Set<string>();

  const handleIntent = (event: Event) => {
    const link = (event.target as Element | null)?.closest?.<HTMLAnchorElement>(INTERNAL_LINK);

    if (!link || warmed.has(link.pathname)) {
      return;
    }

    warmed.add(link.pathname);
    preload(link.pathname);
  };

  INTENT_EVENTS.forEach(name =>
    document.addEventListener(name, handleIntent, { capture: true, passive: true }),
  );

  return () =>
    INTENT_EVENTS.forEach(name => document.removeEventListener(name, handleIntent, true));
};

export default preloadOnIntent;
